import React from 'react';
import { motion } from 'framer-motion';
import { Footprints, Stethoscope, HeartPulse, Apple, BrainCircuit } from 'lucide-react';
const services = [{
  name: 'Plantillas deportivas',
  icon: Footprints
}, {
  name: 'Kinesiología deportiva',
  icon: Stethoscope
}, {
  name: 'Medicina del deporte',
  icon: HeartPulse
}, {
  name: 'Nutrición deportiva',
  icon: Apple
}, {
  name: 'Psicología deportiva',
  icon: BrainCircuit
}];
export function HealthSection() {
  return <section id="salud" className="py-24 bg-kiron-dark relative clip-diagonal-top mt-[-4vw] pt-[calc(6rem+4vw)]" data-id="element-106">
      <div className="max-w-7xl mx-auto px-6" data-id="element-107">
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-108">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:w-1/3" data-id="element-109">
            <h2 className="text-4xl md:text-5xl font-oswald font-bold text-white mb-6 leading-tight" data-id="element-110">
              SALUD Y <br data-id="element-111" />
              <span className="text-kiron-teal" data-id="element-112">RENDIMIENTO</span>
            </h2>
            <p className="text-gray-400 mb-8 font-light leading-relaxed" data-id="element-113">
              El alto rendimiento requiere un enfoque integral. Nuestro equipo
              médico y de rehabilitación trabaja en conjunto con los
              preparadores físicos para optimizar tu cuerpo, prevenir lesiones y
              acelerar tu recuperación.
            </p>
            <a href="https://wa.me/541133016499?text=Hola%20quiero%20agendar%20una%20clase%20de%20prueba" target="_blank" rel="noopener noreferrer" className="inline-block bg-kiron-teal text-kiron-black font-oswald font-bold text-lg px-8 py-4 uppercase tracking-wider hover:scale-105 hover:brightness-110 transition-all duration-300" data-id="element-114">
              Reservá tu evaluación
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-4 w-full" data-id="element-115">
            {services.map((service, index) => <div key={index} className={`bg-kiron-black p-6 flex items-center space-x-4 border-l-2 border-transparent hover:border-kiron-teal transition-all duration-300 ${index === services.length - 1 && services.length % 2 !== 0 ? 'sm:col-span-2 sm:w-1/2 sm:mx-auto' : ''}`} data-id="element-116">
                <service.icon size={32} className="text-kiron-teal flex-shrink-0" data-id="element-117" />
                <span className="font-oswald font-medium text-lg tracking-wide uppercase text-gray-200" data-id="element-118">
                  {service.name}
                </span>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}